// models/metrics/metasearchMetrics/kayak/kayakMetrics.js

// connectivity

// conversion
import MetricBookingcountKayak from "models/metrics/metasearchMetrics/kayak/conversion/MetricBookingcount";
import MetricConversionKayak from "models/metrics/metasearchMetrics/kayak/conversion/MetricConversion";
import MetricRevenuePerclickKayak from "models/metrics/metasearchMetrics/kayak/conversion/MetricRevenuePerclick";
import MetricRoiKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricRoi";

// performance
import MetricClicksKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricClicks";
import MetricCpcKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricCpc";
import MetricCsrKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricCsr";
import MetricGeneratedKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricGenerated";
import MetricImprKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricImpr";
import MetricSpentKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricSpent";

// visibility
import MetricAvgHotelRankKayak from "models/metrics/metasearchMetrics/kayak/visibility/MetricAvgHotelRank";
import MetricAvgposCountKayak from "models/metrics/metasearchMetrics/kayak/performance/MetricAvgposCount";
import MetricPopularHotelKayak from "models/metrics/metasearchMetrics/kayak/visibility/MetricPopularHotel";

const kayakMetrics = [
    // connectivity

    // conversion
    new MetricBookingcountKayak(),
    new MetricConversionKayak(),
    new MetricRevenuePerclickKayak(),
    new MetricRoiKayak(),
    // performance
    new MetricClicksKayak(),
    new MetricCpcKayak(),
    new MetricCsrKayak(),
    new MetricGeneratedKayak(),
    new MetricImprKayak(),
    new MetricSpentKayak(),
    // visibility
    new MetricAvgHotelRankKayak(),
    new MetricAvgposCountKayak(),
    new MetricPopularHotelKayak(),
];

export function findMetricById(metricId) {
    return kayakMetrics.find((metricClass) => metricClass.field === metricId);
}

export default kayakMetrics;
